export class Common {
    public id: number;
    public name: string;
    public description: string;
    public office: string;
    public place: string;
    public schedule: boolean;
    public color: string;
    public created: Date;

    constructor() {
        this.id = 0;
        this.schedule = false;
        this.color = '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6);
    }
}